import React, { useState } from 'react';
import { motion } from 'framer-motion';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import BookingSection from '../components/BookingSection';
import MenuSection from '../components/MenuSection';
import Gallery from '../components/Gallery';
import About from '../components/About';
import Reviews from '../components/Reviews';
import Footer from '../components/Footer';

const HomePage = () => {
  return (
    <div>
      <Navbar />
      <Hero />
      <BookingSection />
      <MenuSection />
      <Gallery />
      <About />
      <Reviews />
      <Footer />
    </div>
  );
};

export default HomePage;
